import { c as _c } from "react/compiler-runtime";
import { Center } from '@chakra-ui/react';
import InvestorProfileCardAnim from '@src/components/sco/Animations/InvestorMatch/InvestorProfileCardAnim';
import { ContentSection } from '@src/components/sco/LayoutBlocks/ContentSection';
import React from 'react';
export const VerifiedInvestorsContent = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      title: "Find Verified Investors",
      href: "/investors/matching/start",
      variant: "cta"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ContentSection componentPlacement="left" description="We show you exactly which investors are the best fit for your deal, and which are the most likely to respond when you reach out. We hand-verify each investor to be sure every opportunity is current." title="Verified Investors. Ranked with Confidence." buttons={t0} component={<Center width="full"><InvestorProfileCardAnim /></Center>} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};